import {
  GET_LIST_TINCHAP,
  GET_LIST_TINCHAP_SUCCESS,
  GET_LIST_TINCHAP_FAILURE,
} from "actions/TinChap/actionTypes";

const initialState = {
  getListTinChapLoading: false,
  posts: [],
  objList: {
    List: [],
    TotalMoney: 0,
    TotalPaid: 0,
    TotalPaidToDateNow: 0,
    TotalQuantity: 0,
  },
  totalRow: 0,
  SoTaiSanThanhLy: 0,
  dataSearch: {},
  isShowFormTinChap: false,
  choVayEditID: 0,
  postTinChapLoading: false,
};

const getListTinChap = (state, action) => ({
  ...state,
  getListTinChapLoading: true,
  dataSearch: action.dataSearch,
});

const getListTinChapSuccess = (state, action) => {
  return {
    ...state,
    getListTinChapLoading: false,
    objList: action.payload,
  };
};

const getListTinChapFailed = (state, action) => ({
  ...state,
  getListTinChapLoading: false,
  objList: {
    List: [],
    TotalMoney: 0,
    TotalPaid: 0,
    TotalPaidToDateNow: 0,
    TotalQuantity: 0,
  },
});

const camdoReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_LIST_TINCHAP:
      return getListTinChap(state, action);
    case GET_LIST_TINCHAP_SUCCESS:
      return getListTinChapSuccess(state, action);
    case GET_LIST_TINCHAP_FAILURE:
      return getListTinChapFailed(state, action);
    default:
      return state;
  }
};

export default camdoReducer;
